import { Flags, ValueOfKey } from '../../../utils-types';

export const SOLUTION_TYPE = {
  NUTRITION: 'NUTRITION',
  SCAN_IQ: 'SCAN_IQ',
  CHALLENGE: 'CHALLENGE',
} as const;

export type SolutionType = ValueOfKey<typeof SOLUTION_TYPE>;
export type SolutionTypeKey = keyof typeof SOLUTION_TYPE;
export type SolutionTypeFlags = Flags<SolutionTypeKey>;

export const SOLUTION_TYPE_FILTER = {
  ...SOLUTION_TYPE,
  ALL: 'ALL',
} as const;

export type SolutionTypeFilter = ValueOfKey<typeof SOLUTION_TYPE_FILTER>;

export const humanizeSolutionType: Record<SolutionType, string> = {
  NUTRITION: 'Nutrition',
  SCAN_IQ: 'ScanIQ',
  CHALLENGE: 'Challenges',
};
